import { render, staticRenderFns } from "./editTextDialog.vue?vue&type=template&id=a2daf2e8&scoped=true"
import script from "./editTextDialog.vue?vue&type=script&lang=js"
export * from "./editTextDialog.vue?vue&type=script&lang=js"
import style0 from "./editTextDialog.vue?vue&type=style&index=0&id=a2daf2e8&prod&lang=less&scoped=true"
import style1 from "./editTextDialog.vue?vue&type=style&index=1&id=a2daf2e8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2daf2e8",
  null
  
)

export default component.exports